export const apiUrl = {
  oktaUserURL: '/v1/userinfo',
  tokenUrl:
    "tokenData",
  url:
    "getAccountDetailsBykey",
  clientID:
    "3MVG9szVa2RxsqBZCdUNvurdG6qOOm.92dhBRaEontmntCN_J5GHIvmOOz7w4r1Kg81dt3Tov_7iZoCUE5naD",
  TokenURI:
      "oauth2/token",
  ForgeRockTokenURI:
    "apexrest/v1/stratusapi/getToken",
  redirectURL: "login2",
  getImages:
    "documentLakeImage",
  getDealerPayments:
    "dealer/paymentMethod",
  submitPayment:
    "dealer/submitPayment",
  AMP:
    "manualPricingList",
  dealerDrop:
    "dealerInfo",
  dealerVehicleCount:
    "dealerVehicleCount",
  manageUser: "manageUser",
  mileageDiscList:
    "mileageList",
  groundListUrl:
    "groundingList",
  getReasonForUpdateMileageUrl:
    'reasonForUpdateMileage',
  getInspectionDamageDetailsUrl:
    "inspectionDamageDetails",
  getOEMBuildDetailsUrl:
    "oemBuildDetails",
  getDealerActionUrl:
    "dealerAction",
  getPurchaseDetailsApi:
    "purchaseDetails",
  getGroundingDetailsURI:
    "groundingDetails",
  getVehicleSaleInfoURI:
    "vehicleSaleInfo",
  getNotesURI:
    "notesList",
  getVehicleStatusHistoryURI:
    "vehicleStatusHistory",
  getCarfaxStatusURI:
    "carfaxStatus",
  getPricingHistory:
    "pricingHistoryList",
  insertNotesURI:
    "notes",
  inspectionAccessoryDetailsUrl:
    "vehicleAccessoryDetails",
  inspectionWheelTiresDetailsUrl:
    "inspectionWheelTiresDetails",
  inspectionVehicleDetails:
    "vehicleInspectionDetails",
  passedVehicleUrl:
    "passedVehicles",
  purchasedVehicleUrl:
    "purchasedVehicles",
  rrm:
    "rRmApprovalList",
  transportDetails:
    "transportationDetails",
  updateMileageURI:
    "mileage",
  updatePricingHistoryURI:
    "pricingHistory",
  updateRRMPrice:
    'rrmAction',
  groundingLite:
    'groundingLite',
  adminSettings:
    'settings',
  purchaseReceipt:
    'dealer/purchaseReceipt',
  dealerInspectionProvider:
    'dealerInspectionProvider',
  dealerDefaults:
    'dealerDefaults',  
  arbitrationList:
    'arbitrationList',
  arbitrationReview:
    'arbitrationReview',
  arbitrationAdminStatusHistory:
    'arbitrationAdminStatusHistory',
  arbitrationStatusUpdate:
    'arbitrationStatusUpdate',
  authAdmin:
    'authAdmin',
  extractList:
    'extractList',
  extract:
    'extract',
  adminSettingsList:
    'adminSettingsList',
  adminSettingsAPI:
    'adminSettings',
  eventsList:
    'eventList',
  events:
    'event',
  healthCheckURI:
    'healthCheck',
  getUngroundingDetailByVIN:
   'ungrounding/ungroundingDetailByVIN',
  getUngroundingReason:
  'ungrounding/reason',
  submitUnground:
  'ungrounding/ungrounding',
};
